// reducers

import { deliveriesSlice } from '@screens/dashboard/slice';

export const reducers = {
  deliveries: deliveriesSlice.reducer,
};
